import { Zoom } from "react-awesome-reveal";
// import { Link } from "react-router-dom";
import React, { useState } from "react";

export const ProjectsItem = ({ item, index, arrows, setArrows }) => {
    // const descriptionItems = Object.values(item.description);
    const [isZoomHovered, setIsZoomHovered] = useState(false);

    const onEnter = () => {
        setIsZoomHovered(true);
    };

    const onLeave = () => {
        setIsZoomHovered(false);
    };

    const onLeft = () => {
        if (arrows[index] > 0) {
            setArrows((prevArrows) => {
                const newArrows = [...prevArrows];
                newArrows[index] = prevArrows[index] - 1;
                return newArrows;
            });
        }
    };

    const onRight = () => {
        const maxItems = item.ImageClass.length - 1;
        if (arrows[index] < maxItems) {
            setArrows((prevArrows) => {
                const newArrows = [...prevArrows];
                newArrows[index] = prevArrows[index] + 1;
                return newArrows;
            });
        }
    };

    const imgLinks = `${item.ImageClass[arrows[index]]}`;
    return (
        <div
            className="Project-Item"
            onMouseEnter={onEnter}
            onMouseLeave={onLeave}
        >
            <Zoom className="ImageClassZoom hoverable">
                <div className="Link-Images">
                    <i
                        className="fa-solid fa-chevron-left  pulseOn"
                        onClick={onLeft}
                    ></i>

                    <div
                        style={{
                            backgroundImage: `url(${imgLinks})`,
                        }}
                        className="projects-img lazy-load"
                    ></div>

                    <i
                        className="fa-solid fa-chevron-right pulseOn"
                        onClick={onRight}
                    ></i>
                </div>
            </Zoom>

            <div className="Project-Name-Cont">
                <a href={item.link} className="Project-Name" target="blank_">
                    {item.name}
                </a>
            </div>
        </div>
    );
};
